import { render } from "./WildLand.vue?vue&type=template&id=2de79ec4"
import script from "./WildLand.vue?vue&type=script&lang=js"
export * from "./WildLand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/WildLand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2de79ec4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2de79ec4', __exports__)) {
    api.reload('2de79ec4', __exports__)
  }
  
  module.hot.accept("./WildLand.vue?vue&type=template&id=2de79ec4", () => {
    api.rerender('2de79ec4', render)
  })

}


export default __exports__